import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { VIEW, EDIT, DELETE } from "const"
import { QidCompany } from "server/models"
import { qidCompaniesRoute } from "client/parts/routes"
import {
    PRM_QID_COMPANY,
    StoreType,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Logo,
    Link,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const companyLink = (company: QidCompany, linkContent: any) => {
        const href = `${qidCompaniesRoute}/${VIEW}/${company.id}`
        return (
            <Link
                href={href}
                onClick={() => dispatch(addModal({ url: href }))}
            >
                {linkContent}
            </Link>
        )
    }

    const editAccess = hasAccess(PRM_QID_COMPANY, EDIT)
    const deleteAccess = hasAccess(PRM_QID_COMPANY, DELETE)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (company: QidCompany) => (
                companyLink(company, <Logo table logo={company.logo || Images.qidCompanyLogo} />)
            ),
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (company: QidCompany) => companyLink(company, company.name),
        },
    ]

    if (editAccess) {
        columns.push(
            {
                field: "status",
                header: lang.status,
                centerAlign: true,
                sortable: true,
                editAccess: () => true,
            },
            {
                field: "createdAt",
                header: lang.created,
                sortable: true,
                formatter: (company: QidCompany) => <DateFormatter date={company.createdAt} />,
            },
        )
    }

    if (deleteAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
